import type { ReactNode } from 'react';
import clsx from 'clsx';
import { ControlPlaneSurface } from './ControlPlaneSurface';

export interface ControlPlaneDataSurfaceProps {
  children: ReactNode;
  toolbar?: ReactNode;
  className?: string;
}

/** Shared data-workspace surface; feature code owns the table. */
export function ControlPlaneDataSurface({ children, toolbar, className }: ControlPlaneDataSurfaceProps) {
  return (
    <ControlPlaneSurface noPadding className={clsx('vania-control-plane-data-surface', className)}>
      {toolbar}
      <div className="vania-control-plane-data-surface__content">{children}</div>
    </ControlPlaneSurface>
  );
}
